import { toast } from 'react-toastify';
import { DefaultAjax, modalForbidden } from './DefaultAjax';
import * as FaIcons from "react-icons/fa";
import i18n from "i18n-react";
import { Table } from 'reactstrap';
import { DynamicMap, ArrayString, IntervalDayAndHour, Boolean, ArrayOfMap, DynamicSelectedValues, DynamicInputValue, MultipleSelectedOptionShowTemplate } from "../pages/templateConfigs/TemplateConfigs";
import DynamicMapTemplate from "../pages/templateConfigs/DynamicMapTemplate";
import ArrayTemplate from "../pages/templateConfigs/ArrayTemplate";
import IntervalDayAndHourTemplate from "../pages/templateConfigs/IntervalDayAndHourTemplate";
import BooleanTemplate from "../pages/templateConfigs/BooleanTemplate";
import ArrayOfMapTemplate from "../pages/templateConfigs/ArrayOfMapTemplate";
import SelectGIE from "./SelectGIE";
import Select from 'react-select';
import DynamicSelectedValuesTemplate from "../pages/templateConfigs/DynamicSelectedValuesTemplate";
import DefaultSpinner from './DefaultSpinner';
import DynamicInputValueTemplate from '../pages/templateConfigs/DynamicInputValueTemplate';
import { getDynamicInputValues } from '../pages/templateConfigs/getDynamicInputValue';
import MultipleSelectedOptionTemplate from '../pages/templateConfigs/MultipleSelectedOption';

const FE_DEFAULT_FROM_EMAIL = "FE_DEFAULT_FROM_EMAIL";

export const windowHistoryReplaceState = (independent, instanceType) => {
    if (!independent || !instanceType) {
        independent = document.querySelector("#independent").value;
        instanceType = document.querySelector("#instanceType").value;
    }
    if (document.querySelector("#token") != null && document.querySelector("#token").value !== '') {
        window.history.replaceState(null, document.title, window.location.origin + "/" + '?independent=' + independent + '?instanceType=' + instanceType + '?module=' + document.querySelector("#currentModule").value + "?token=" + document.querySelector("#token").value);
    }
}

export const dateRangeForSearh = (date) => {
    let startDate = new Date(date);
    let m = startDate.getMonth() + 1;
    let mes = (m < 10) ? '0' + m : m;
    let day = startDate.getDate();
    let dayForShow = (day < 10) ? '0' + day : day;
    startDate = dayForShow + "-" + mes + "-" + startDate.getFullYear();
    return startDate;
}

export function handleDateRangeCallback(start, end, setState) {
    const dateRange = [];
    document.querySelector("#dateInInputStart").value = dateRangeForSearh(start._d);
    document.querySelector("#dateInInputEnd").value = dateRangeForSearh(end._d);
    dateRange.push(dateRangeForSearh(start._d));
    dateRange.push(dateRangeForSearh(end._d));
    setState({
        dateRange: dateRange,
        startDate: start._d,
        endDate: end._d
    });
}

export const redirectToPlatform = (platformUrl, pathRoot, token, html, module) => {
    window.location.href = platformUrl + pathRoot + "login/receiptTokenFromAppWeb?tokenOfUser=" + token + "&urlToRedirect=/html/" + html + "?lang=es?module=" + module;
}

export const toastFunction = (message, type) => {
    if (type === "success") {
        return toast.success(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    } else if (type === "error") {
        return toast.error(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    } else if (type === "warning") {
        return toast.warning(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

}

export const catchErrorAjax = (error, setState) => {
    setState({
        modalContent: "",
        spinner: "",
        component: error.message
    });
    if (error.response) {
        if (error.response.status === 403) {
            setTimeout(() => {
                setState({ modalContent: modalForbidden() });
            }, 10);
        }
    }
}

export const executeDefaultReport = (startDate, endDate, setState, url, nameOfDocument, useOrgNodeFilter = true) => {
    const orgNodeType = document.querySelector(".modalBody .selectType")?.value || "";
    const model = {
        dateStart: startDate,
        dateEnd: endDate,
        type: "",
        user: "",
        gon: "",
        ion: ""
    };

    if (!useOrgNodeFilter) {
        executeReportRequest(model, setState, url, nameOfDocument);
        return;
    }

    if (orgNodeType === '') {
        toastFunction(i18n.translate("select_org_node"), "warning");
    } else {
        model.type = orgNodeType;
        model.user = document.querySelector(".modalBody #userSelected")?.value || "";
        model.gon = document.querySelector(".modalBody #groupSelected")?.value || "";
        model.ion = document.querySelector(".modalBody #profileSelected")?.value || "";

        if (orgNodeType === "1" && model.ion === '') {
            toastFunction(i18n.translate("select_org_node"), "warning");
        } else if (orgNodeType === "2" && model.gon === '') {
            toastFunction(i18n.translate("select_org_node"), "warning");
        } else {
            executeReportRequest(model, setState, url, nameOfDocument);
        }
    }
}

const executeReportRequest = (model, setState, url, nameOfDocument) => {
    setState({
        spinner: <DefaultSpinner instanceType={document.querySelector("#instanceType").value}
            independent={document.querySelector("#independent").value} />
    })
    DefaultAjax('', 'blob').get(url + '?reportDtoJson=' + encodeURI(JSON.stringify(model)))
        .then((res) => {
            setState({
                spinner: ""
            });
            if (res.status === 200) {

                const FileDownload = require('js-file-download');

                toastFunction(i18n.translate("download_started"), "success");
                setState({
                    modalReport: false,
                    defaulValueConfigsModal: false,
                    optionDefaulValueConfigs: null,
                    modalContent: ""
                });

                FileDownload(res.data, nameOfDocument + '.xlsx');

            } else {

                toastFunction(i18n.translate("an_error_has_ocurred"), "error");

            }
        }).catch((error) => {
            catchErrorAjax(error, setState);
        });
}

export const handleKeyDown = (e) => {
    // Verifica si la combinación es Ctrl+V
    if (e.ctrlKey && e.key === 'v') {
        // Permite el comportamiento predeterminado para Ctrl+V
        return;
    }

    // Permite la tecla Tab sin modificar el comportamiento
    if (e.key === 'Tab' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        return;
    }

    // Permite las teclas numéricas, Backspace y Delete
    if (/^\d$/.test(e.key) || e.key === 'Backspace' || e.key === 'Delete' || e.key === 'Control') {
        return;
    }

    // Evita el comportamiento predeterminado para otras teclas
    e.preventDefault();
};

export const handlePaste = (e) => {
    e.preventDefault(); // Evita el comportamiento de pegado por defecto

    const text = e.clipboardData.getData('text/plain'); // Obtiene el texto del portapapeles
    const onlyDigits = text.replace(/[^\d]/g, ''); // Filtra solo dígitos

    const target = e.target; // Obtiene el input objetivo
    const { selectionStart, selectionEnd, value } = target; // Obtiene la posición del cursor y el valor actual

    // Construye el nuevo valor para el input
    const newValue = value.substring(0, selectionStart) + onlyDigits + value.substring(selectionEnd);

    // Actualiza el valor del input directamente
    target.value = newValue;

    // Establece la posición del cursor después del texto pegado
    target.setSelectionRange(selectionStart + onlyDigits.length, selectionStart + onlyDigits.length);

    // Si hay un manejador de eventos onChange, invócalo manualmente
    const event = new Event('input', { bubbles: true });
    target.dispatchEvent(event);
};


export const calculateScroll = (toRest) => {
    let nav = document.querySelector("#nav-top").offsetHeight;
    let navbar = 0;
    if (document.querySelector(".navbar")) {
        navbar = document.querySelector(".navbar").offsetHeight;
    }
    let altura = window.innerHeight - nav - navbar - toRest;
    let bodyContent = document.querySelector("#bodyContent");
    bodyContent.style.maxHeight = altura + "px";
}

export const configNavContent = (selectOrgType, selectKeyConfig, getFeConfigs) => (
    <>
        <nav className='navbar'>
            <div className='contentInput row divIndex' style={{ width: '40%' }}>
                <div style={{ display: 'inline-block' }} className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                    <label>{i18n.translate("description")}</label>
                    {selectKeyConfig}
                </div>
                {' '}
                {selectOrgType}
            </div>
            <div style={{ paddingTop: "22px" }}>
                <div style={{ display: 'inline-block' }} className="divIndex" onClick={() => getFeConfigs(false, true)}>
                    <button className='buttonMzateSecondary'>
                        <FaIcons.FaSearch />
                        <span>{i18n.translate("default_search")}</span>
                    </button>
                </div>
                {' '}
                <div style={{ display: 'inline-block' }} className="divIndex">
                    <button className='buttonMzateSecondary' onClick={() => getFeConfigs("search")}>
                        <FaIcons.FaSearch />
                        <span>{i18n.translate("default_show_all")}</span>
                    </button>
                </div>
                <div style={{ display: 'none' }} className="divShow">
                    <button className='buttonMzateSecondary' onClick={() => getFeConfigs("search", false)}>
                        <FaIcons.FaLongArrowAltLeft />
                        <span>{i18n.translate("default_back")}</span>
                    </button>
                </div>
            </div>
        </nav>
        <div></div>
    </>
)

export const configIndexContent = (configs, prepareToShowConfig) => (
    <Table className='table table-hover divIndexTable'>
        <tbody>
            <tr>
                <th className='firstcell'>{i18n.translate("description")}</th>
                <th className='cellgroup'>{i18n.translate("values")}</th>
            </tr>
            {configs.map((con) => {
                return (
                    <tr className='cellOptions' key={con.key} onClick={() => prepareToShowConfig(con)} >
                        <td>
                            {!con.isVisible && <FaIcons.FaEyeSlash />}
                            {i18n.translate(con.key)}
                        </td>
                        <td className='text cellgroup'>
                            {con.companySettingType === "DYNAMIC_MAP" && <DynamicMap array={con} />}
                            {con.companySettingType === "ARRAY_STRING" && <ArrayString array={con} />}
                            {con.companySettingType === "INTERVAL_DAY_AND_HOUR" && <IntervalDayAndHour array={con} />}
                            {con.companySettingType === "BOOLEAN" && <Boolean array={con} />}
                            {con.companySettingType === "ARRAY_OF_MAP" && <ArrayOfMap array={con} />}
                            {con.companySettingType === "DYNAMIC_SELECTED_VALUES" && <DynamicSelectedValues array={con} />}
                            {con.companySettingType === "DYNAMIC_INPUT_VALUE" && <DynamicInputValue array={con} />}
                            {con.companySettingType === "MULTIPLE_SELECTED_OPTION" && <MultipleSelectedOptionShowTemplate array={con} configKey={con.key} />}
                            {con.key === FE_DEFAULT_FROM_EMAIL &&
                                <ul>
                                    {con.detail.map((det) => (
                                        <li key={det.id}>
                                            {det.type === 0 &&
                                                <b>{i18n.translate("default_predeterminated")}: </b>
                                            }
                                            {det.type !== 0 &&
                                                <b>{det.description}: </b>
                                            }
                                            {det.value}
                                        </li>
                                    ))}
                                </ul>
                            }
                        </td>
                    </tr>
                )
            })}
        </tbody>
    </Table>
)

export const configTemplateToUse = (config) => {
    let templateToUse = "?=?";
    if (config.companySettingType === "DYNAMIC_MAP") {
        templateToUse = <DynamicMapTemplate array={config} />;
    } else if (config.companySettingType === "ARRAY_STRING") {
        templateToUse = <ArrayTemplate array={config} />;
    } else if (config.companySettingType === "INTERVAL_DAY_AND_HOUR") {
        templateToUse = <IntervalDayAndHourTemplate array={config} />;
    } else if (config.companySettingType === "BOOLEAN") {
        templateToUse = <BooleanTemplate array={config} />;
    } else if (config.companySettingType === "ARRAY_OF_MAP") {
        templateToUse = <ArrayOfMapTemplate array={config} />;
    } else if (config.companySettingType === "DYNAMIC_SELECTED_VALUES") {
        templateToUse = <DynamicSelectedValuesTemplate array={config} />;
    } else if (config.companySettingType === "DYNAMIC_INPUT_VALUE") {
        templateToUse = <DynamicInputValueTemplate array={config} />;
    } else if (config.companySettingType === "MULTIPLE_SELECTED_OPTION") {
        templateToUse = <MultipleSelectedOptionTemplate array={config} />;
    }
    return templateToUse;
}

const getTypeSelect = (setState) => {
    let configurationOrgNodeId;
    if (document.querySelector(".modalBody .selectType").value === "1") {
        configurationOrgNodeId = document.querySelector(".modalBody #profileSelected").value;
        setState({ optionSelectedDescription: document.querySelector(".modalBody #profileSelectedDescription").value })
    } else if (document.querySelector(".modalBody .selectType").value === "2") {
        configurationOrgNodeId = document.querySelector(".modalBody #groupSelected").value;
        setState({ optionSelectedDescription: document.querySelector(".modalBody #groupSelectedDescription").value })
    } else {
        configurationOrgNodeId = document.querySelector(".modalBody #userSelected").value;
        setState({ optionSelectedDescription: document.querySelector(".modalBody #userSelectedDescription").value })
    }
    return configurationOrgNodeId;
}

const getConfigsValues = (configuration, config, setState) => {
    configuration.key = config.key;
    configuration.functionalityGroup = config.functionalityGroup;
    configuration.id = null;
    configuration.companySettingType = config.companySettingType;
    configuration.tenantId = config.detail[0].tenantId;
    configuration.orgNodeId = getTypeSelect(setState);
    configuration.type = document.querySelector(".modalBody .selectType").value;
    configuration.username = "username";
    configuration.fullname = "fullname";
    return configuration;
}
const alertSelectType = () => {
    toastFunction(i18n.translate("select_org_node"), "warning");
}

export const hasExistingConfiguration = (config, configuration) => {
    if (!config || !Array.isArray(config.detail)) {
        return false;
    }
    return config.detail.some((detail) =>
        String(detail.type) === String(configuration.type) &&
        String(detail.assignedId) === String(configuration.orgNodeId)
    );
}

const createNewConfigValue = (configuration, config, setState, getFunctionsConfigs) => {
    if (configuration.value === "" || configuration.value === undefined
        || configuration.value == null) {
        toastFunction(i18n.translate("value_cannot_be_empty"), "error");
    } else if (hasExistingConfiguration(config, configuration)) {
        toastFunction(i18n.translate("configuration_already_exists"), "warning");
    } else {
        DefaultAjax('').post("companySetting/companySetting", configuration)
            .then((res) => {
                if (res) {
                    let result = JSON.parse(res.data);
                    if (result === 0 || result === "0") {
                        toastFunction(i18n.translate("configuration_created"), "success");
                        setState(prevState => ({
                            config: {
                                ...prevState.config,
                                show: false
                            },
                            modalContent: "",
                            html: "",
                            modalInsertar: false
                        }))
                        getFunctionsConfigs(true, true);
                    } else {
                        toastFunction(i18n.translate("an_error_has_ocurred"), "error");
                    }
                }
            }).catch((error) => {
                catchErrorAjax(error, setState);
            });
    }
}

export const validateConfigToCreate = (config, setState, getFunctionsConfigs) => {
    let configuration = {};
    const validSettingsType = ["BOOLEAN", "DYNAMIC_SELECTED_VALUES", "DYNAMIC_INPUT_VALUE"];
    const isValid = validSettingsType.includes(config.companySettingType);


    if (!isValid || config.update) {
        return;
    }

    const selectTypeValue = document.querySelector(".modalBody .selectType").value;
    if (selectTypeValue === "") {
        alertSelectType();
        return;
    }

    if (config.companySettingType === "DYNAMIC_INPUT_VALUE") {
        let result = getDynamicInputValues();
        configuration.value = JSON.stringify(result);
    } else {
        configuration.value = document.querySelector(".modalBody .newValue").value;
    }

    configuration = getConfigsValues(configuration, config, setState);
    if (configuration.orgNodeId === "") {
        alertSelectType();
    } else {
        createNewConfigValue(configuration, config, setState, getFunctionsConfigs);
        setState({ configurationPostSave: configuration });
    }
};

export const getValuesForSearchConfig = () => {
    let orgNodeId;
    const selectType = document.querySelector(".contentInput .selectType");
    const profileSelected = document.querySelector(".contentInput #profileSelected");
    const groupSelected = document.querySelector(".contentInput #groupSelected");
    const userSelected = document.querySelector(".contentInput #userSelected");

    const type = selectType.value;

    switch (type) {
        case '1':
            orgNodeId = profileSelected.value;
            break;
        case '2':
            orgNodeId = groupSelected.value;
            break;
        case '3':
            orgNodeId = userSelected.value;
            break;
        default:
            orgNodeId = '';
    }

    return { orgNodeId, type };
};

export const fetchConfigs = (orgNodeId, type, key, functionalityGroup, isSupportImpersonation = false) => {
    return DefaultAjax('')
        .get(`companySetting/companySettings?isSupportImpersonation=${isSupportImpersonation}&assignedId=${orgNodeId}&key=${key}&type=${type}&functionalityGroup=${functionalityGroup}`)
        .then(res => {
            if (res) {
                return JSON.parse(res.data);
            }
            throw new Error('No response data');
        });
};

export const processConfigs = (result, handleChange, moduleCode) => {
    let optionsKey = [];
    optionsKey.push({ value: "", label: i18n.translate("default_all") });
    for (let i = 0; i < result.length; i++) {
        optionsKey.push({ value: result[i].key, label: i18n.translate(result[i].key) });
    }

    let selectOrgType = <SelectGIE moduleCode={moduleCode} classSelect={"col-sm-12 col-md-4 col-lg-4 col-xl-4 selectGIE"} classSelectType={"col-sm-12 col-md-4 col-lg-4 col-xl-4"} />;
    let selectKeyConfig = <Select onChange={handleChange} options={optionsKey} defaultValue={{ label: optionsKey[0].label, value: optionsKey[0].value }} />;

    return { selectOrgType, selectKeyConfig };
};


export const updateStateAfterFetch = (isSearch, result, setState, selectOrgType, selectKeyConfig, prepareToShowConfig, getFeConfigs) => {
    const stateUpdate = {
        spinner: "",
        configs: result,
        configIndexContent: configIndexContent(result, prepareToShowConfig),
    };

    if (!isSearch) {
        stateUpdate.configNavContent = configNavContent(selectOrgType, selectKeyConfig, getFeConfigs);
    }

    setState(stateUpdate);

    setTimeout(() => {
        calculateScroll(50);
    }, 20);
};


export const handleError = (error, setState) => {
    catchErrorAjax(error, setState);
};

export const handleSidebarOptions = (event, isFromSubMenu) => {
    let a = document.querySelectorAll(".sidebar2 a");
    for (let item of a) {
        item.classList.remove("active");
    }

    let svg = document.querySelectorAll(".sidebar2 svg");
    for (let item of svg) {
        item.style.color = "rgb(255, 255, 255)";
    }

    let span = document.querySelectorAll(".sidebar2 a span");
    for (let item of span) {
        item.classList.remove("active")
    }

    if (isFromSubMenu) {
        handleSidebarOptionsSubMenu(event)
    } else {
        handleSidebarOptionsMenu(event)
    }
}

export const handleSidebarOptionsSubMenu = (event) => {
    let platformUrl = document.querySelector("#platformUrl").value;
    let pathRoot = document.querySelector("#pathRoot").value;
    let token = document.querySelector("#token").value;
    let goToPlatform = false;

    let html = "";

    if (event.target.id === "administrationConfigurations" || event.target.id === "administrationWebAccess" ||
        event.target.id === "administrationBlocking" || event.target.id === "administrationReports"||
    event.target.id === "ordersPlatform" || event.target.id === "ordersProducts" || event.target.id === "ordersImport"
    ) {
        goToPlatform = true;
        html = "dashboardMain.html";
    }

    if (goToPlatform) {
        redirectToPlatform(platformUrl, pathRoot, token, html, event.target.id)
    }

    let subMenusItems = document.querySelectorAll(".submenu a");
    for (let item of subMenusItems) {
        item.classList.remove("active")
    }

    event.target.classList.add("active");
    event.target.children[1].classList.add("active");
    const submenu = event.target.closest('.submenu');
    submenu.previousElementSibling.classList.add("active");
    submenu.previousElementSibling.children[0].children[0].style.color = 'rgb(141, 190, 34)';
    submenu.previousElementSibling.children[0].children[1].classList.add("active");
}

export const handleSidebarOptionsMenu = (event) => {
    let platformUrl = document.querySelector("#platformUrl").value;
    let pathRoot = document.querySelector("#pathRoot").value;
    let token = document.querySelector("#token").value;

    let goToPlatform = false;

    let html = "";
    
    if(event.target.id === "myAccountInformation" || event.target.id === "myAccountBilling" || event.target.id === "myAccountOperations" || 
    event.target.id === "administrationUsers" || event.target.id === "administrationAdministration" || 
    event.target.id === "administrationStablishments" || event.target.id === "administrationPermissions" || 
    event.target.id === "administrationConfiguration" || event.target.id === "administrationSecurity" || 
    event.target.id === "administrationNotification" || event.target.id === "administrationOperations" || 
    event.target.id === "administrationAudit" || event.target.id === "administrationIntegration" ||
    event.target.id === "ordersPlatform" || event.target.id === "ordersTaxes" ||
    event.target.id === "ordersPriceList" || event.target.id === "ordersConfiguration"){
        goToPlatform = true;
        html = "dashboardMain.html";
    } else if (event.target.id === "mzatePlatform") {
        goToPlatform = true;
        html = "dashboard.html";
    }

    if (goToPlatform) {
        redirectToPlatform(platformUrl, pathRoot, token, html, event.target.id)
    }
    event.target.classList.add("active");
    event.target.children[0].children[0].style.color = 'rgb(141, 190, 34)';
    event.target.children[0].children[1].classList.add("active");
    if (event.target.nextElementSibling) {
        event.target.nextElementSibling.children[0].classList.add("active");
        event.target.nextElementSibling.children[0].children[1].classList.add("active");
    }
}

export const handleIndexDefaultSearchButton = (e, callback) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        callback();
    }
};
